import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/forms';
import '@angular/router';
import '@angular/http';

import 'rxjs';

import 'bootstrap/dist/js/bootstrap';



// WEBPACK FOOTER //
// ./src/vendor.ts